import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import GrowlyyLogo from '../common/GrowlyyLogo';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-growlyy-primary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="col-span-1 md:col-span-1">
            <div className="mb-4">
              <GrowlyyLogo className="text-white" size="small" />
            </div>
            <p className="text-gray-300 mb-4">
              L'agence de prospection qui fonctionne à la performance. Nous générons des rendez-vous qualifiés pour votre entreprise.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                <FaFacebook size={20} />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                <FaTwitter size={20} />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                <FaInstagram size={20} />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition duration-300">
                <FaLinkedin size={20} />
              </a>
            </div>
          </div>

          {/* Liens rapides */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li><a href="#accueil" className="text-gray-300 hover:text-white transition duration-300">Accueil</a></li>
              <li><a href="#fonctionnalites" className="text-gray-300 hover:text-white transition duration-300">Fonctionnalités</a></li>
              <li><a href="#temoignages" className="text-gray-300 hover:text-white transition duration-300">Témoignages</a></li>
              <li><a href="#tarifs" className="text-gray-300 hover:text-white transition duration-300">Tarifs</a></li>
              <li><a href="#faq" className="text-gray-300 hover:text-white transition duration-300">FAQ</a></li>
            </ul>
          </div>

          {/* Nos services */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Nos services</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition duration-300">Prospection Email</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition duration-300">Prospection LinkedIn</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition duration-300">Prospection Téléphonique</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition duration-300">Génération de leads</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition duration-300">Qualification de prospects</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Paris, France</li>
              <li>contact@growlyy.com</li>
              <li>+33 7 56 90 33 68</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-growlyy-primary-light mt-8 pt-8 text-center text-gray-300">
          <p>&copy; {new Date().getFullYear()} Growlyy. Tous droits réservés.</p>
          <div className="mt-2 flex justify-center space-x-4 text-sm">
            <Link to="/conditions-utilisation" className="hover:text-white transition duration-300">
              Conditions d'utilisation
            </Link>
            <span>|</span>
            <Link to="/politique-confidentialite" className="hover:text-white transition duration-300">
              Politique de confidentialité
            </Link>
            <span>|</span>
            <a href="#" className="hover:text-white transition duration-300">Mentions légales</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 